<template lang="html">
  <div class="setup-component">
    <v-container>
  <v-card>
    <v-tabs show-arrows grow centered>
      <v-row justify="center">
      <v-tab>
        <v-icon left>drive_eta</v-icon>
        Vezetési karton
      </v-tab>
      <v-tab v-if="admin">
        <v-icon left>article</v-icon>
        Szerződés sablonok
      </v-tab>
      <v-tab v-if="admin">
        <v-icon left>adb</v-icon>
        Fejlesztői beállítások
      </v-tab>
      </v-row>
      <v-tab-item>
          <KartonSetup></KartonSetup>
      </v-tab-item>
      <v-tab-item>
          <ContractSetup></ContractSetup>
      </v-tab-item>
      <v-tab-item>
          <DevSetup></DevSetup>
      </v-tab-item>
    </v-tabs>
  </v-card>
</v-container>
  </div>
</template>

<script>
import KartonSetup from '../components/karton_setup.vue'
import DevSetup from '../components/dev_setup.vue'
import ContractSetup from '../components/contract_setup.vue'
import store from '../store'
import {
  mapFields
} from 'vuex-map-fields'

  export default {
    components: {
      KartonSetup,
      DevSetup,
      ContractSetup
    },
    data () {
      return {
      }
    },
    methods: {
    },
    mounted() {
    },
    computed: {
    ...mapFields([
      'auth.loginuser',
      'auth.placeid',
      'auth.phoneNumber',
      'auth.fbuser',
      'auth.admin',
  ]),
  },
  }
</script>

<style lang="css">
</style>
